<script lang="ts">
    import type { HTMLImgAttributes } from "svelte/elements";
    import type { Image } from "~/types";
    import { cn } from "~/utils";

    interface $$Props extends HTMLImgAttributes {
        image: Image;
        maxWidth?: number;
        maxHeight?: number;
    }

    export let image: Image;
    export let maxWidth: number | undefined = undefined;
    export let maxHeight: number | undefined = undefined;

    const src = image.src.startsWith("http") ? image.src : `https:${image.src}`;
    let url = new URL(src);
    if (maxWidth != null) {
        url.searchParams.set("width", maxWidth.toString());
    }
    if (maxHeight != null) {
        url.searchParams.set("height", maxHeight.toString());
    }
</script>

<img
    width={image.width}
    height={image.height}
    src={url.toString()}
    {...$$restProps}
    alt={image.alt ?? $$restProps.alt}
    class={cn("object-contain", $$restProps.class)}
/>
